import React from 'react'
import { Stack, Typography } from '@mui/material'

import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

export interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  primaryActionText: string
  title: string
  description: string
}

const ConfirmFormSubmitDialog: React.FC<Props> = ({ onClose, isOpen, onConfirm, primaryActionText, title, description }) => {
  const { t } = useCustomTranslation()

  const modalActions = {
    primary: {
      name: primaryActionText,
      onClick: onConfirm,
    },
    secondary: { name: t('common.cancel'), onClick: onClose },
  }

  return (
    <Dialog maxWidth="sm" title={title} actions={modalActions} onClose={onClose}>
      <Stack>
        <Typography variant="body2">{description}</Typography>
      </Stack>
    </Dialog>
  )
}

export default ConfirmFormSubmitDialog
